import * as user from './user/actions';

export default { user };
